import usePageMetadata from '@hooks/usePageMetadata'

const useIsInHerotellingPage = (): boolean => {
  const pageMetadata = usePageMetadata()
  return pageMetadata.targetContentSubType === 'hero'
}

export default useIsInHerotellingPage
